<div class="modal-container">
  @if(isMobileDevice){
  <div class="rectangle-line-mobile-view mt-2" mat-dialog-close>
    <img src="../../../assets/images/rectangle-line.svg" />
  </div>
  }
  <mat-dialog-content class="modal-content">
    <div class="container">
      <div class="image-container">
        <img src="/assets/images/success.svg" class="image" />
        <!-- <img src="/assets/images/cross_white.svg" class="image" /> -->
      </div>
      <div class="close-button" mat-button (click)="onCloseDialog()">
        <mat-icon class="close-icon">close</mat-icon>
      </div>
      <div class="text-container">
        <h1 class="title">{{ data.mainHeading }}</h1>
        <p class="subtitle">{{ data.subHeading }}</p>
      </div>
      <div class="form-actions">
        @if (!data.routeNavigate) {
        <button class="save-button dp-primary-btn" (click)="onCloseDialog()">
          {{ data.buttonValue }}
        </button>
        } @else{
        <button
          [routerLink]="data.routerLink"
          class="save-button dp-primary-btn"
          (click)="onCloseDialog()"
        >
          {{ data.buttonValue }}
        </button>
        }
      </div>
    </div>
  </mat-dialog-content>
</div>
